import moment from 'moment'
import angular from 'angular'
import intl from 'react-intl-universal'
// import _ from 'lodash'
import dataWranglingUtils from '../dataWrangling/utils.js'
import exceptionTypes from '../errors/exception.types.js'

const _publishActionTypeLog = []
const _trimTypeLog = function _trimTypeLog() {
  const seen = []
  for (let idx = _publishActionTypeLog.length - 1; idx > 0; idx--) {
    let type = _publishActionTypeLog[idx]
    if (seen.indexOf(type) >= 0) {
      _publishActionTypeLog.splice(idx, 1)
      continue
    }
    seen.push(type)
  }
}
let _loaded = false
const _angularModules = {}
const _loadAngularModules = function _loadAngularModules() {
  if (_loaded === true) {
    return true
  }
  _loaded = true
  _angularModules['$filter'] = angular
    .element(window.document.getElementsByTagName('html'))
    .injector()
    .get('$filter')
}

export class StateRequest {
  constructor(currentState = 'close', updateDatum = false) {
    this.state = currentState
    this.updateDatum = updateDatum
  }
}
export class PublishActionTime {
  constructor(time, type = 'plain') {
    if (angular.isUndefined(time) || time === null) {
      time = moment.utc().tz(window.org_settings.timezone)
    }
    _loadAngularModules()

    if (time.constructor !== moment.utc().constructor) {
      if (!angular.isDate(time)) {
        throw new exceptionTypes.TypeException({
          message: `Invalid type: {typeof time}`,
          errors: [time],
        })
      }

      this.time = moment(time).tz(window.org_settings.timezone)
    } else {
      this.time = time
    }

    this.time = time
    this.type = type

    // Used for debugging
    _publishActionTypeLog.push(type)
    _trimTypeLog()
    // console.log('_publishActionTypeLog', _publishActionTypeLog)
  }
  get asDisplayTime() {
    if (this.type.endsWith('-now')) {
      return new PublishActionTime(this.time.clone(), 'display-time-now')
    }
    return new PublishActionTime(this.time.clone(), 'display-time')
  }
  get isValidMessage() {
    return intl.get('publishActions.publishField.error')
  }
  get isValid() {
    if (this.time < PublishActionTime.CaptureBaseline('backward')) {
      return false
    }
    return true
  }
  get asMoment() {
    return this.time
  }
  get asTimeCode() {
    if (this.type.endsWith('-now')) {
      return `${intl.get('publishActions.publishModal.boltNow')}`
    }
    let timeCode = _angularModules['$filter']('dateDisp')(
      this.time,
      'MMM D, Y h:mm a'
    )
    if (this.type.startsWith('planned-')) {
      return `${timeCode} (${intl.get(
        'publishActions.publishModal.boltPlanned'
      )})`
    }
    if (this.type.startsWith('current-')) {
      return `${timeCode} (${intl.get(
        'publishActions.publishModal.boltExisting'
      )})`
    }
    return timeCode
  }

  get asClone() {
    return new PublishActionTime(this.time.clone(), this.type)
  }
  static wrangleDisplayTime(storyObj) {
    let displayTime = dataWranglingUtils.selectFirst(
      dataWranglingUtils.extractProperties(storyObj, ['display_date']),
      [
        [dataWranglingUtils.isStringType, dataWranglingUtils.ansStringToDate],
        [
          dataWranglingUtils.isDateType,
          function itemToMoment(item) {
            return moment(item).tz(window.org_settings.timezone)
          },
        ],
      ],
      undefined
    )

    if (displayTime === undefined) {
      return new PublishActionTime(displayTime, 'display-time-now')
    }

    return new PublishActionTime(displayTime, 'display-time-ud')
  }
  static wranglePublishTime(storyObj) {
    let publishTime = dataWranglingUtils.selectFirst(
      dataWranglingUtils.extractProperties(storyObj, [
        'publish_date',
        'planning.scheduling.planned_publish_date',
        'planning.scheduling.scheduled_publish_date',
      ]),
      [
        [dataWranglingUtils.isStringType, dataWranglingUtils.ansStringToDate],
        [
          dataWranglingUtils.isDateType,
          function itemToMoment(item) {
            return moment(item).tz(window.org_settings.timezone)
          },
        ],
      ],
      undefined
    )

    if (
      publishTime === undefined ||
      publishTime < PublishActionTime.CaptureBaseline()
    ) {
      return new PublishActionTime(
        moment.utc().tz(window.org_settings.timezone),
        'publish-time-now'
      )
    }

    return new PublishActionTime(publishTime, 'publish-time')
  }
  static CaptureBaseline(vector = 'forward') {
    const offset = 4
    const unit = 'minutes'
    if (vector === 'forward') {
      return moment
        .utc()
        .add(offset, unit)
        .tz(window.org_settings.timezone)
    } else if (vector === 'backward') {
      return moment
        .utc()
        .subtract(offset, unit)
        .tz(window.org_settings.timezone)
    } else {
      throw new exceptionTypes.InvalidAttribute(
        `vector[${vector}] passed is not supported`
      )
    }
  }
}
